import neutral_girl from "../../assets/images/neutral_girl.webp";
import fight_girl from "../../assets/images/fight_girl.webp";
import defeated_girl from "../../assets/images/defeated_girl.webp";
import neutral_boy from "../../assets/images/neutral_boy.webp";
import { ImageGrid } from "./ImageGrid";
import background from "../../assets/images/hongkong_bg.webp";

export const Home = () => {
  const backgroundStyle: React.CSSProperties = {
    backgroundImage: `url(${background})`,
    backgroundSize: "cover", // ensures it fills the space
    backgroundPosition: "center", // centers the image nicely
    backgroundRepeat: "no-repeat",
    minHeight: "100vh", // make sure it fills the viewport
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  return (
    <div style={backgroundStyle}>
      <ImageGrid
        leftImages={[neutral_girl, fight_girl, defeated_girl]}
        rightImages={[neutral_boy]}
      />
    </div>
  );
};
